import React from 'react';
import Navbar from './navbar'; // Assurez-vous que votre Navbar est importée ici
import Footer from './footer';
import { Container } from '@mui/material';
import { Outlet } from 'react-router-dom';
import useArchiveMonitor from '../hooks/useArchiveMonitor';

const Layout = () => {
  // Surveiller le statut d'archivage de l'utilisateur connecté
  useArchiveMonitor();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <Container component="main" sx={{ flex: 1, marginTop: 3 }}>
        <Outlet/>
      </Container>
      <Footer />
    </div>
  );
};

export default Layout;
